import React from 'react';
import * as R from 'ramda';

export const DeleteModal = ({service, addOrRemove}) => {
    return (
    <div className="modal fade px-0" id="deleteService" aria-labelledby="deleteServiceLabel" aria-hidden="true">
        <div className="modal-dialog px-2">
            <div className="modal-content">
                <div className="modal-header">
                    <div className="alert bg-alert-danger rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
                        <h1 className="sr-only visually-hidden">Supprimer</h1>
                        <div className="flex-row align-items-center justify-content-between">
                            <div className="h4 font-weight-demi text-danger text-uppercase mb-0 ls-n1 lh-1 mx-auto" id="infoValiderLabel">Supprimer demarche</div>
                            <button type="button" className="btn btn-close btn-icon p-0 mr-0" data-dismiss="modal" aria-label="Close">
                                <i className="eva eva-close fs-4"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <div className="modal-body text-center">
                    <img className="img-fluid mb-3" src={R.isNil(service) ? '' : service.icon} alt={R.isNil(service) ? '' : service.title} />
                    <div className="fs-sm ls-n1">Etes-vous sûr(e) de vouloir supprimer la démarche <strong>"{R.isNil(service) ? '' : service.title}"</strong>?</div>
                    <div className="fs-3 o-60">Cette action est irréversible.</div>
                </div>
                <div className="modal-footer justify-content-center">
                        <button type="button" className="btn btn-faded" data-dismiss="modal" aria-label="Close">Annuler</button>
                        <button type="button" className="btn btn-danger" data-dismiss="modal" onClick={(e) => {
                            e.preventDefault();
                            if (!R.isNil(service)) {
                                addOrRemove(service.connectionType);
                            }
                        }}>Supprimer</button>
                </div>
            </div>
        </div>
    </div>
    );
}